export default "__VITE_ASSET__C2R_VwoM__"